<div class="smart-banner-container">
    <img src="{{ DEPLOY_URL }}/assets/images/smart-banner-close.svg" alt="close-banner" class="close" (click)="close()" />
    <img src="{{ DEPLOY_URL }}/assets/images/smart_banner_logo.png" alt="logo" class="logo" />
    <div class="discount-container">
        <b>{{ staticText.app_offer.discount }}</b> {{ staticText.app_offer.discount_condition }}
        <br />
        Use code: <b>{{ staticText.app_offer.discount_code }}</b>
        <br />
        <img src="{{ DEPLOY_URL }}/assets/images/five_star_rating.svg" alt="rating" class="star-rating" />
        {{ staticText.smartBanner.download_info }}
        <br />
    </div>
    <button class="install" (click)="install()">Install</button>
</div>
